import React, { useState } from 'react'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { useCart } from '../context/CartContext'
import { toFaDigits } from '../utils/format'

const NAV_ITEMS = [
  { to: '/', label: 'خانه', end: true },
  { to: '/products', label: 'محصولات', end: false },
  { to: '/cart', label: 'سبد خرید', end: false }
]

const Header: React.FC = () => {
  const { user, logout } = useAuth()
  const { items } = useCart()
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const count = items.reduce((sum, i) => sum + i.quantity, 0)

  const handleLogout = async () => {
    await logout()
    navigate('/')
  }

  return (
    <header className="bg-[#faf6ef]/95 backdrop-blur shadow-sm sticky top-0 z-40 border-b-0 gold-vein">
      <div className="container-main">
        <div className="flex items-center justify-between py-3 gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0 min-w-0">
            <img src="/favicon.svg" alt="" className="w-9 h-9" />
            <div className="min-w-0">
              <div className="font-black text-primary-600 leading-none">طلا و نقره</div>
              <div className="text-[11px] text-gray-500 truncate hidden xs:block sm:block">خرید و فروش آنلاین شمش، آب‌شده و فلزات قیمتی</div>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-3 lg:gap-6 text-sm font-medium">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to + item.label}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  isActive ? 'text-primary-600 font-bold border-b-2 border-primary-500' : 'text-gray-600 hover:text-primary-600'
                }
              >
                {item.label}
                {item.to === '/cart' && count > 0 && (
                  <span className="mr-1 bg-primary-100 text-primary-800 text-[11px] rounded-full px-2">{toFaDigits(count)}</span>
                )}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-2 lg:gap-3">
            {user ? (
              <>
                <Link to="/profile" className="btn btn-secondary !py-2">{user.firstName} {user.lastName}</Link>
                <Link to="/orders" className="btn btn-outline !py-2">سفارش‌ها</Link>
                <button className="btn btn-danger !py-2" onClick={handleLogout}>خروج</button>
              </>
            ) : (
              <>
                <Link to="/login" className="btn btn-secondary !py-2">ورود</Link>
                <Link to="/register" className="btn btn-primary !py-2">ثبت‌نام</Link>
              </>
            )}
          </div>

          <button className="md:hidden btn btn-secondary !p-2" onClick={() => setOpen(!open)} aria-label="منو">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2">
              {open ? <path d="M6 6 L14 14 M14 6 L6 14" /> : <path d="M4 5 H16 M4 10 H16 M4 15 H16" />}
            </svg>
          </button>
        </div>

        {open && (
          <div className="md:hidden border-t mt-1 flex flex-col gap-1 py-2 text-sm">
            {NAV_ITEMS.map((item) => (
              <Link key={item.to + item.label} to={item.to} onClick={() => setOpen(false)} className="px-3 py-2 rounded hover:bg-primary-50">
                {item.label}
                {item.to === '/cart' && count > 0 && (
                  <span className="mr-2 bg-primary-100 text-primary-800 text-[11px] rounded-full px-2">{toFaDigits(count)}</span>
                )}
              </Link>
            ))}
            {user ? (
              <>
                <Link to="/profile" onClick={() => setOpen(false)} className="px-3 py-2 rounded hover:bg-primary-50">پروفایل</Link>
                <Link to="/orders" onClick={() => setOpen(false)} className="px-3 py-2 rounded hover:bg-primary-50">سفارش‌های من</Link>
                <button className="px-3 py-2 rounded text-right text-red-600 hover:bg-red-50 w-full" onClick={() => { setOpen(false); handleLogout() }}>
                  خروج
                </button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)} className="px-3 py-2 rounded hover:bg-primary-50">ورود</Link>
                <Link to="/register" onClick={() => setOpen(false)} className="px-3 py-2 rounded hover:bg-primary-50">ثبت‌نام</Link>
              </>
            )}
          </div>
        )}
      </div>
    </header>
  )
}

export default Header